import initSlickWithArrowEvent from "../../components/slick-utils";

function initShopProductSectionProductsSlider(slider) {
    if (!$(slider).hasClass('maier-carousel-list')) {
        return;
    }

    const slick = initSlickWithArrowEvent(
        $(slider),
        {
            dots: false,
            dotsClass: 'slick-dots',
            prevArrow: '<span class="slide-arrow prev">Prev</span>',
            nextArrow: '<span class="slide-arrow next">Next</span>',
            autoplay: false,
            infinite: false,
            speed: 300,
            slidesToShow: 3,
            slidesToScroll: 3,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    }
                },
                {
                    breakpoint: 575,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    }
                }
            ]
        }
    );
}

function observeShopProductSectionProductsSlider() {
    // IntersectionObserver
    const intersectionObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                initShopProductSectionProductsSlider(entry.target);
                intersectionObserver.unobserve(entry.target);
            }
        });
    }, {rootMargin: '200px 0px'});

    document.querySelectorAll('.maier-wrapper-shop-product-section-products .maier-section-products-list').forEach(slider => intersectionObserver.observe(slider));

    // MutationObserver
    const mutationObserver = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.addedNodes.length >= 1) {
                for (var i = 0; i < mutation.addedNodes.length; i++) {
                    if (undefined !== mutation.addedNodes[i].localName) {
                        mutation.addedNodes[i].querySelectorAll('.maier-wrapper-shop-product-section-products .maier-section-products-list').forEach(slider => initShopProductSectionProductsSlider(slider));
                    }
                }
                ;
            }
        });
    });

    mutationObserver.observe(document.body, { attributes: false, childList: true, characterData: false, subtree: true });
}

function setupMaierSectionProducts() {
    requestAnimationFrame(() => {
        requestAnimationFrame(() => {
            observeShopProductSectionProductsSlider();
        })
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupMaierSectionProducts);
} else {
    setupMaierSectionProducts();
}

